import { createFileRoute } from '@tanstack/react-router';
import { CompanyAdminPage } from '@/features/company-admin';

export const Route = createFileRoute('/_app/admin/compani')({
  component: CompanyAdminPage,
});
